<template>
  <v-row
    class="c-settings-modal"
    justify="center"
  >
    <v-dialog
      v-model="dialog"
      scrollable
      max-width="430"
      @click:outside="closeModal()"
    >
      <v-card class="px-8 py-8">
        <div class="c-settings-modal__content">
          <p class="c-settings-modal__title">Налаштування</p>
          
          <div
            v-for="item in slider_list"
            :key="item.obj_key"
            class="mb-5"
          >
            <div class="c-settings-modal__slider-title">
              {{ item.title }}
            </div>

            <v-slider
              class="v-slider-custom"
              v-model="settings[item.obj_key]"
              :max="tickLabels(item.obj_key).length - 1"
              step="1"
              :tick-labels="tickLabels(item.obj_key)"
              ticks="always"
              tick-size="2"
              color="#2E2C3D"
              track-color="#C4C4C4"
              thumb-color="#2E2C3D"
            ></v-slider>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'c-settings-modal',
  data() {
    return {
      dialog: false,
      tick_labels_default: [ 'Дрібний', 'Середній', 'Великий'],
      tick_labels_by_line_size: [ 'Дрібна', 'Середня', 'Велика' ],
      slider_list: [
        { title: 'Розмір шрифту', obj_key: 'font_size'},
        { title: 'Розмір елементів', obj_key: 'element_size'},
        { title: 'Ширина лінії маршруту', obj_key: 'line_size'}
      ],
      settings: {}
    }
  },
  watch: {
    settings: {
      handler(val) {
        this.$store.commit('SETTINGS_UI', val)
      }
    }
  },
  methods: {
    openModal() {
      this.applySettings()
      this.dialog = true
    },
    closeModal() {
      this.dialog = false
    },
    applySettings() {
      let val = this.$store.getters.SETTINGS_UI
      this.settings = { ...val }
    },
    tickLabels(key) {
      return key == 'line_size' ? this.tick_labels_by_line_size : this.tick_labels_default
    }
  }
}
</script>

<style lang="scss">
  .c-settings-modal {
    &__content {
      color: #2E2C3D;
    }
    &__title {
      font-size: 1.5rem;
      font-weight: 700;
      margin-left: 6px;
    }
    &__text {
      font-size: 18px;
    }
    &__slider-title {
      font-size: 18px;
      margin-bottom: 10px;
      margin-left: 6px;
    }
  }
</style>